module.exports = __webpack_public_path__ + "img/jeremy_img.8dbe2087.png";